import {FeatureVariantAssignmentsMap} from '@udemy-v2/react-experimentation';

export const COURSE_VARIATION_FEATURE_CODE = 'default_control_price_price_engine_variant_1';

interface CourseVariationFeatureConfig {
    cv_ui_aggregated_reviews: boolean;
    cv_ui_overview: boolean;
    cv_ui_ratings_disclaimer: boolean;
}

export const getCourseVariationFeatureConfig = (
    featureAssignments: FeatureVariantAssignmentsMap,
): CourseVariationFeatureConfig | undefined => {
    return featureAssignments.get(COURSE_VARIATION_FEATURE_CODE)?.configuration
        ?.data as CourseVariationFeatureConfig;
};
